var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLearningAdaptiveCorrectBottom = function SvgLearningAdaptiveCorrectBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#2B81FC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.2258,
    cy: 10.5735,
    r: 3.79076,
    fill: "#68A2F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0973 19.4977C30.761 20.1614 30.761 21.2374 30.0973 21.901L23.2998 28.6986C22.6361 29.3622 21.5602 29.3622 20.8965 28.6986L17.4977 25.2998C16.8341 24.6361 16.8341 23.5602 17.4977 22.8965C18.1614 22.2329 19.2374 22.2329 19.901 22.8965L22.0981 25.0936L27.694 19.4977C28.3577 18.8341 29.4337 18.8341 30.0973 19.4977Z",
    fill: "white"
  })));
};
export default SvgLearningAdaptiveCorrectBottom;